/* eslint-disable import/no-cycle */
import api from './api.service';

function index(params) {
  return api.get('/bullettins/', params);
}

function get(id, params) {
  return api.get(`/bullettins/${id}`, params);
}

function create(params) {
  return api.post('/bullettins', params);
}

export const bullettinService = {
  index,
  get,
  create,
};
